import { cva } from '@/styled-system/css';

export const buttonLabelRecipe = cva({
  base: {
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'color 200ms ease',
    },
  },
  variants: {
    tone: {
      'brand': {},
      'neutral': {},
      'neutral-fixed': {},
      'critical': {},
    },

    emphasis: {
      filled: {},
      outlined: {},
      bare: {},
    },

    disabled: {
      true: {},
      false: {},
    },
    onImpact: {
      true: {},
      false: {},
    },
    loading: {
      true: {
        color: 'transparent.invisible',
      },
      false: {},
    },
    size: {
      sm: {
        textStyle: 'body-sm-bold',
      },
      md: {
        textStyle: 'body-bold',
      },
      lg: {
        textStyle: 'body-bold',
      },
    },
  },
  compoundVariants: [
    {
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.onHero.action.neutral.default',
        },
      },
    },
    {
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.onHero.action.neutral.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.action.hero.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'text.neutral',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.action.critical.hero.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'text.action.neutral-fixed.default',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.action.hero.default',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.action.critical.hero.default',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'text.neutral',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'text.action.neutral-fixed.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.action.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.neutral',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.action.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.action.critical.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.action.critical.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'text.action.neutral-fixed.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.neutral-fixed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.action.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.action.critical.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.neutral',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.neutral-fixed',
        },
      },
    },
    {
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.onHero.action.neutral.default',
        },
      },
    },
    {
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.onHero.action.neutral.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.action.hero.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'text.neutral',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.action.critical.hero.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'text.action.neutral-fixed.default',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.action.hero.default',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.action.critical.hero.default',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'text.neutral',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'text.action.neutral-fixed.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.action.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.neutral',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.action.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.action.critical.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.action.critical.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'text.action.neutral-fixed.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.neutral-fixed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.action.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.action.critical.hero.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.neutral',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'neutral-fixed',
      loading: false,
      css: {
        color: {
          base: 'text.onImpact.neutral-fixed',
        },
      },
    },
    {
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.onHero.action.neutral.hover',
          _groupActive: 'text.onHero.action.neutral.pressed',
        },
      },
    },
    {
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.onHero.action.neutral.hover',
          _groupActive: 'Button.filled.critical.label.pressed',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.hero.hover',
          _groupActive: 'text.action.hero.pressed',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.neutral',
          _groupActive: 'text.neutral',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.critical.hero.hover',
          _groupActive: 'text.action.critical.hero.pressed',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral-fixed',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.neutral-fixed.hover',
          _groupActive: 'text.action.neutral-fixed.pressed',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.accent.blue.strong-fixed',
          _groupActive: 'text.accent.blue.strong-fixed',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.critical.hero.hover',
          _groupActive: 'text.action.critical.hero.pressed',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'neutral',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.neutral-fixed',
          _groupActive: 'text.neutral-fixed',
        },
      },
    },
    {
      emphasis: 'bare',
      tone: 'neutral-fixed',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.neutral-fixed.hover',
          _groupActive: 'text.action.neutral-fixed.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.hero.hover',
          _groupActive: 'text.action.hero.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.neutral',
          _groupActive: 'text.neutral',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.hero.hover',
          _groupActive: 'text.action.hero.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.critical.hero.hover',
          _groupActive: 'text.action.critical.hero.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.critical.hero.hover',
          _groupActive: 'text.action.critical.hero.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'neutral-fixed',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.neutral-fixed.hover',
          _groupActive: 'text.action.neutral-fixed.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral-fixed',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.neutral-fixed',
          _groupActive: 'text.neutral-fixed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.hero.hover',
          _groupActive: 'text.action.hero.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.critical.hero.hover',
          _groupActive: 'text.action.critical.hero.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'neutral',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.neutral',
          _groupActive: 'text.neutral',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'bare',
      tone: 'neutral-fixed',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.neutral-fixed',
          _groupActive: 'text.neutral-fixed',
        },
      },
    },
  ],
});
